var map = {
	"./assets/barcode.svg": "2ac6",
	"./assets/boost.jpg": "9a8c",
	"./assets/boost.svg": "b3b3",
	"./assets/checkmark.svg": "e3eb",
	"./assets/colour-star.svg": "b0da",
	"./assets/crossmark.svg": "6f54",
	"./assets/dummy_user.png": "47f0",
	"./assets/energy.jpg": "48e4",
	"./assets/energy.svg": "24d6",
	"./assets/garden.jpg": "4782",
	"./assets/garden.svg": "01ef",
	"./assets/grey-star.svg": "0e05",
	"./assets/help_icon.svg": "e44e",
	"./assets/indoor-light.png": "b93a",
	"./assets/inside-border.png": "3dc9",
	"./assets/left-arrow-icon.svg": "e612",
	"./assets/lify.svg": "1c40",
	"./assets/logo.svg": "c3b3",
	"./assets/panoptic_ai.svg": "2642",
	"./assets/panoptic_ai_vitals.png": "5d25",
	"./assets/revive.jpg": "def4",
	"./assets/revive.svg": "0ec7",
	"./assets/silh_no_neck.png": "1691",
	"./assets/silh_with_neck.png": "27fc",
	"./assets/sleep.jpg": "1127",
	"./assets/sleep.svg": "3055",
	"./assets/sooth.jpg": "8a43",
	"./assets/sooth.svg": "1ae2",
	"./assets/steady-laptop.jpg": "6d88",
	"./assets/steady-phone.jpg": "72ae",
	"./assets/sunrise.jpg": "c1f5",
	"./assets/sunrise.svg": "bde2",
	"./assets/sunset.jpg": "0790",
	"./assets/sunset.svg": "3dfc",
	"./assets/switch-camera.svg": "11c9",
	"./assets/teatox.jpg": "e486",
	"./assets/teatox.svg": "c1ab",
	"./assets/whole-face.png": "ea6c",
	"./bounding-box-view": "2d5a",
	"./bounding-box-view.vue": "2d5a",
	"./breathing-circle": "29b9",
	"./breathing-circle.vue": "29b9",
	"./camera": "3a8b",
	"./camera.js": "3a8b",
	"./card-content": "90b0",
	"./card-content.vue": "90b0",
	"./circular-progress": "183e",
	"./circular-progress.vue": "183e",
	"./condition-icon": "9d20",
	"./condition-icon.vue": "9d20",
	"./conditions-hud": "1921",
	"./conditions-hud.vue": "1921",
	"./face-detection-view": "a5cf",
	"./face-detection-view.vue": "a5cf",
	"./face-landmarks-detection": "c54d",
	"./face-landmarks-detection.js": "c54d",
	"./face-mesh-view": "6364",
	"./face-mesh-view.css": "8d30",
	"./face-mesh-view.vue": "6364",
	"./home-page": "0537",
	"./home-page.vue": "0537",
	"./information-box": "68a1",
	"./information-box.vue": "68a1",
	"./plans": "6b71",
	"./plans.js": "6b71",
	"./quiz": "3f0b",
	"./quiz.vue": "3f0b",
	"./result": "175e",
	"./result-box": "7631",
	"./result-box.vue": "7631",
	"./result.vue": "175e",
	"./scan-tutorial": "cf8d",
	"./scan-tutorial.vue": "cf8d",
	"./signal-quality-box": "bc0d",
	"./signal-quality-box-floating": "8b4f",
	"./signal-quality-box-floating.vue": "8b4f",
	"./signal-quality-box.vue": "bc0d",
	"./user-profile-input": "0f2d",
	"./user-profile-input.vue": "0f2d",
	"./video-feed": "6ae8",
	"./video-feed.vue": "6ae8",
	"./vital-sign-button": "1796",
	"./vital-sign-button-js": "7842",
	"./vital-sign-button-js.vue": "7842",
	"./vital-sign-button.vue": "1796",
	"./vital-signs/blood-pressure": "a9b1",
	"./vital-signs/blood-pressure.vue": "a9b1",
	"./vital-signs/bmi": "fe8d",
	"./vital-signs/bmi.vue": "fe8d",
	"./vital-signs/covid-risk": "41d2",
	"./vital-signs/covid-risk.vue": "41d2",
	"./vital-signs/cvd-risk": "d039f",
	"./vital-signs/cvd-risk.vue": "d039f",
	"./vital-signs/data-hud": "9b0d",
	"./vital-signs/data-hud.vue": "9b0d",
	"./vital-signs/facial-skin-age": "b5d9",
	"./vital-signs/facial-skin-age.vue": "b5d9",
	"./vital-signs/heart-rate": "4d22",
	"./vital-signs/heart-rate.vue": "4d22",
	"./vital-signs/hrv-ibi": "a637",
	"./vital-signs/hrv-ibi.vue": "a637",
	"./vital-signs/hrv-rmssd": "a410",
	"./vital-signs/hrv-rmssd.vue": "a410",
	"./vital-signs/hrv-sdnn": "650f",
	"./vital-signs/hrv-sdnn.vue": "650f",
	"./vital-signs/o2-saturation": "25c1",
	"./vital-signs/o2-saturation.vue": "25c1",
	"./vital-signs/respiratory-rate": "b0e8",
	"./vital-signs/respiratory-rate.vue": "b0e8",
	"./vital-signs/stress-rating": "2036",
	"./vital-signs/stress-rating.vue": "2036",
	"./vital-signs/temperature": "a18d",
	"./vital-signs/temperature.vue": "a18d",
	"./vital-signs/wellness": "fc12",
	"./vital-signs/wellness.vue": "fc12"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "96ad";